import React from 'react'

import moment from 'moment'
import _ from 'underscore'

import {Colors, Card, Caption, P, Icon, S2, Badge, Row} from '../UI/index.js'
import {getListAddresses} from '../../../utils/retourAddresses.js'

export default class OrderCard extends React.Component {
    constructor(props) {
        super(props)

        const getToLateAddresses = (order) => {
            const toLateAddresses = {first: false, multi: false, last: false}

            order.addresses.map((address, index) => {
                const toLate = !address.hasArrived && moment().isAfter(moment(`${order.date} ${address.endTime}`, 'YYYY-MM-DD HH:mm'))

                if (index === 0) {
                    toLateAddresses.first = toLate
                } else if (index === order.addresses.length - 1) {
                    toLateAddresses.last = toLate
                } else if (toLate) {
                    toLateAddresses.multi = true
                }
            })

            return toLateAddresses
        }

        this.state = {
            toLateAddresses: getToLateAddresses(this.props.order)
        }

        this.interval = setInterval(() => {
            const toLateAddresses = getToLateAddresses(this.props.order)

            if (toLateAddresses.first !== this.state.toLateAddresses.first || toLateAddresses.multi !== this.state.toLateAddresses.multi || toLateAddresses.last !== this.state.toLateAddresses.last) {
                this.setState({toLateAddresses})
            }
        }, 6000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    render() {
        const {toLateAddresses} = this.state
        const {order, showDate = false, showCustomer = true, onClick, reseller} = this.props

        const {firstAddress, lastAddress, firstIsOriginal, retourAddress, nrOfOtherAddresses} = getListAddresses(order)

        // The original address of a retour is no longer part of the order, the retour address is the order's only address
        const firstToLate = !firstIsOriginal && toLateAddresses.first
        const lastToLate = firstIsOriginal ? toLateAddresses.first : toLateAddresses.last

        const customerName = `${order.senderAddress?.name || ''}${order.senderAddress?.name ? ` (${order.customerAddress?.name})` : order.customerAddress?.name}`

        return (
            <Card
                shadow='true'
                style={{flexDirection: 'column', padding: '0px 6px 0px 6px', marginLeft: 6, marginRight: 3, marginBottom: 6, height: 'auto'}}
                onClick={onClick}
            >

                <Row style={{flexShrink: 0, alignItems: 'center', height: 24}}>

                    {showCustomer &&
                        <Caption ellipsis style={{flex: 1}}>{customerName}</Caption>
                    }

                    {showDate &&
                        <Caption ellipsis style={{flex: 1}}>{moment(order.date).format('DD-MM-YYYY')}</Caption>
                    }

                    <Caption ellipsis style={{flex: 1, textAlign: 'right'}}>{order.reference}</Caption>
                </Row>

                {firstAddress &&
                    <div style={{opacity: firstIsOriginal ? 0.6 : 1}}>
                        <Row style={{flexShrink: 0, alignItems: 'center', height: 24, position: 'relative'}}>
                            <div
                                style={{
                                    position: 'absolute',
                                    background: firstIsOriginal ? Colors.grey40 : firstAddress === retourAddress ? Colors.retour : Colors[firstAddress.type],
                                    width: 6,
                                    height: 45,
                                    left: -12,
                                    top: 0,
                                    borderRadius: '4px 0 0 4px'
                                }}
                            />

                            {firstToLate &&
                                <Icon size='md' style={{marginRight: 6, color: Colors.errorBright}} icon='mdi mdi-clock-alert-outline' />
                            }

                            {!firstAddress.position && !firstIsOriginal &&
                                <Icon size='md' style={{marginRight: 6, color: Colors.errorBright}} icon='mdi mdi-alert' />
                            }

                            <P ellipsis style={{flex: 1}}>{`${firstAddress.street} ${firstAddress.nr}${firstAddress.addition} ${firstAddress.postalCode} ${firstAddress.city}`}</P>
                            <Caption ellipsis>{`${firstAddress.startTime} - ${firstAddress.endTime}`}</Caption>
                        </Row>

                        <Row style={{flexShrink: 0, alignItems: 'center', height: 21}}>
                            <Icon size='md' style={{marginRight: 6, color: Colors.textMedium}} icon={firstAddress.isBusiness ? 'mdi mdi-store-outline' : 'mdi mdi-account'} />
                            <Caption ellipsis style={{flex: 1}}>{firstAddress.name}</Caption>
                        </Row>

                        {reseller.settings.orders.showOptionsInPlanning === 'yes' && !firstIsOriginal && (
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                {firstAddress.gpsRequired &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-map-marker' />
                                }
                                {firstAddress.signatureRequired &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-fountain-pen-tip' />
                                }
                                {firstAddress.nameRequired && !firstAddress.signatureRequired &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-signature-text' />
                                }
                                {firstAddress.signatureNeighbors &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-home-edit-outline' />
                                }
                                {firstAddress.statedAddressOnly &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-home' />
                                }
                                {firstAddress.mailboxDelivery &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-mailbox-open-up' />
                                }
                                {firstAddress.refrigerated &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-snowflake' />
                                }
                                {firstAddress.scanRequired &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-barcode-scan' />
                                }
                                {firstAddress.imageRequired &&
                                    <Icon style={{marginRight: 6, fontSize: 20}} icon='mdi mdi-camera' />
                                }
                                {firstAddress.minimumAge &&
                                    <div style={{fontSize: 14, fontWeight: 500, marginRight: 6}}>{`${firstAddress.minimumAge}+`}</div>
                                }
                                {firstAddress.idCheck &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-card-account-details-outline' />
                                }
                                {firstAddress.verificationCode &&
                                    <Icon style={{marginRight: 6, fontSize: 20}} icon='mdi mdi-shield-key-outline' />
                                }
                            </div>
                        )}

                        {reseller.settings.orders.showOptionsInPlanning !== 'no' && !firstIsOriginal && firstAddress.customOptions?.length > 0 && (
                            <Row style={{flexShrink: 0, alignItems: 'center', paddingBottom: 2, gap: 4, flexWrap: 'wrap'}}>
                                {firstAddress.customOptions.map((option) => {
                                    const optionObj = reseller.settings.orders.customOptions?.find((o) => o.id === option)

                                    return optionObj ? <Badge key={optionObj.id} size='sm' color={optionObj.color}>{optionObj.name}</Badge> : null
                                })}
                            </Row>
                        )}
                    </div>
                }

                {nrOfOtherAddresses > 0 &&
                    <Row style={{flexShrink: 0, alignItems: 'center', justifyContent: 'center', height: 21}}>
                        <div style={{flex: 1, height: 1, background: Colors.grey30, marginRight: 12}} />

                        {toLateAddresses.multi &&
                            <Icon size='md' style={{marginRight: 6, color: Colors.errorBright}} icon='mdi mdi-clock-alert-outline' />
                        }

                        {_.some(order.addresses.slice(1, -1), (address) => !address.position) &&
                            <Icon size='md' style={{marginRight: 6, color: Colors.errorBright}} icon='mdi mdi-alert' />
                        }

                        <S2>{`+${nrOfOtherAddresses}`}</S2>

                        <div style={{flex: 1, height: 1, background: Colors.grey30, marginLeft: 12}} />
                    </Row>
                }

                {lastAddress &&
                    <>

                        <Row style={{flexShrink: 0, alignItems: 'center', height: 24, position: 'relative'}}>
                            <div
                                style={{
                                    position: 'absolute',
                                    background: lastAddress === retourAddress ? Colors.retour : Colors[lastAddress.type],
                                    width: 6,
                                    height: 45,
                                    left: -12,
                                    top: 0,
                                    borderRadius: '4px 0 0 4px'
                                }}
                            />

                            {lastToLate &&
                                <Icon size='md' style={{marginRight: 6, color: Colors.errorBright}} icon='mdi mdi-clock-alert-outline' />
                            }

                            {!lastAddress.position &&
                                <Icon size='md' style={{marginRight: 6, color: Colors.errorBright}} icon='mdi mdi-alert' />
                            }

                            <P ellipsis style={{flex: 1}}>{`${lastAddress.street} ${lastAddress.nr}${lastAddress.addition} ${lastAddress.postalCode} ${lastAddress.city}`}</P>
                            <Caption ellipsis>{`${lastAddress.startTime} - ${lastAddress.endTime}`}</Caption>
                        </Row>

                        <Row style={{flexShrink: 0, alignItems: 'center', height: 21}}>
                            <Icon size='sm' style={{marginRight: 6, color: Colors.textMedium}} icon={lastAddress.isBusiness ? 'mdi mdi-store-outline' : 'mdi mdi-account'} />
                            <Caption ellipsis style={{flex: 1}}>{lastAddress.name}</Caption>
                        </Row>

                        {reseller.settings.orders.showOptionsInPlanning === 'yes' && (
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                {lastAddress.gpsRequired &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-map-marker' />
                                }
                                {lastAddress.signatureRequired &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-fountain-pen-tip' />
                                }
                                {lastAddress.nameRequired && !lastAddress.signatureRequired &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-signature-text' />
                                }
                                {lastAddress.signatureNeighbors &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-home-edit-outline' />
                                }
                                {lastAddress.statedAddressOnly &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-home' />
                                }
                                {lastAddress.mailboxDelivery &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-mailbox-open-up' />
                                }
                                {lastAddress.refrigerated &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-snowflake' />
                                }
                                {lastAddress.scanRequired &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-barcode-scan' />
                                }
                                {lastAddress.imageRequired &&
                                    <Icon style={{marginRight: 6, fontSize: 20}} icon='mdi mdi-camera' />
                                }
                                {lastAddress.minimumAge &&
                                    <div style={{fontSize: 14, fontWeight: 500, marginRight: 6}}>{`${lastAddress.minimumAge}+`}</div>
                                }
                                {lastAddress.idCheck &&
                                    <Icon style={{fontSize: 20, marginRight: 3}} icon='mdi mdi-card-account-details-outline' />
                                }
                                {lastAddress.verificationCode &&
                                    <Icon style={{marginRight: 6, fontSize: 20}} icon='mdi mdi-shield-key-outline' />
                                }
                            </div>
                        )}

                        {reseller.settings.orders.showOptionsInPlanning !== 'no' && lastAddress.customOptions?.length > 0 && (
                            <Row style={{flexShrink: 0, alignItems: 'center', paddingBottom: 2, gap: 4, flexWrap: 'wrap'}}>
                                {lastAddress.customOptions.map((option) => {
                                    const optionObj = reseller.settings.orders.customOptions?.find((o) => o.id === option)

                                    return optionObj ? <Badge key={optionObj.id} size='sm' color={optionObj.color}>{optionObj.name}</Badge> : null
                                })}
                            </Row>
                        )}
                    </>
                }

                {order.notes &&
                    <Row style={{flexShrink: 0, alignItems: 'center', height: 21}}>
                        <Icon size='sm' style={{marginRight: 6, color: Colors.textMedium}} icon='mdi mdi-message-outline' />
                        <Caption ellipsis style={{flex: 1}}>{order.notes}</Caption>
                    </Row>
                }
            </Card>
        )
    }
}
